// @flow
import React, {
  Component,
} from 'react';
import {
  DateTime,
} from 'luxon';

import type {
  IntervalType,
  DatePickerMode,
} from 'chronos-types';

import ChevronLeft from 'chronos-assets/images/chevron-left.svg';
import ChevronRight from 'chronos-assets/images/chevron-right.svg';
import CalendarIcon from 'chronos-assets/images/calendar-default.svg';

import {
  Popup,
} from 'chronos-components';

import PickerPopup from './PickerPopup';
import {
  DatePickerContainer,
  DatePickerTrigger,
  DatePickerJumptoControl,
  DatePickerCalendarIcon,
} from './styled';

import {
  jumpToDate,
} from './utils';

type Props = {
  /**
   * Mode of picking, one of 'Day' | 'Week' | 'Month' | 'Custom'
   * */
  mode: DatePickerMode,
  /**
   * Inverval
   * */
  date: IntervalType,
  /**
   * Function that is called whenever the date changes.
   * */
  onChange: { (date: IntervalType, position: string): void },
   /**
   * Function that is called when apply clocked
   * */
  onApply: { (date: IntervalType): void },
  /**
   * Function that is called after changes mode
   * */
  onChangeMode: { (mode: DatePickerMode): void },
  /**
   * Function that is called after close
   * */
  onClose: { (): void },
};

type State = {
  isOpen: boolean,
};

/* eslint-disable react/destructuring-assignment, react/jsx-one-expression-per-line */
class DatePicker extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  setPopupVisible = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
    }));
  }

  handleOuterAction = (e: Event) => {
    if (e) {
      this.setState({
        isOpen: false,
      });
      this.props.onClose();
    }
  }

  handleJumpToDate = (dir: string) => {
    const date = jumpToDate(
      this.props.mode,
      dir,
      this.props.date,
    );
    this.props.onChange(date);
    if (this.props.onApply) {
      this.props.onApply(date);
    }
  };

  render() {
    const {
      date,
      mode,
    } = this.props;
    return (
      <DatePickerContainer>
        <DatePickerJumptoControl
          src={ChevronLeft}
          onClick={() => this.handleJumpToDate('Prev')}
        />
        <Popup
          isOpen={this.state.isOpen}
          preferPlace="below"
          handleOuterAction={this.handleOuterAction}
          setPopupVisible={this.setPopupVisible}
          trigger={(
            <DatePickerTrigger>
              {date.start.toLocaleString(DateTime.DATE_FULL)} –{' '}
              {date.end.toLocaleString(DateTime.DATE_FULL)}
              <DatePickerCalendarIcon src={CalendarIcon} />
            </DatePickerTrigger>
          )}
        >
          <PickerPopup
            date={date}
            mode={mode}
            onChange={this.props.onChange}
            showApplyButton={false}
            onApply={() => {
              this.setPopupVisible();
              if (this.props.onApply) {
                this.props.onApply(date);
              }
            }}
            onClickMode={this.props.onChangeMode}
            jumpToDateRequest={this.handleJumpToDate}
          />
        </Popup>
        <DatePickerJumptoControl
          src={ChevronRight}
          onClick={() => this.handleJumpToDate('Next')}
        />
      </DatePickerContainer>
    );
  }
}

export default DatePicker;
